





































import { FormQuestion } from "@/store/modules/types";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class MultipleChoiceAnswer extends Vue {
  @Prop() readonly question!: FormQuestion;
  select() {
    const checked = this.question
      .options!.list.filter((opt) => opt.checked)
      .map((opt) => opt.value);

    const list = this.question
      .options!.list.filter((opt) => opt.checked && opt.updateGap)
      .map((opt) => opt.updateGap);

    const updateGap: any = [];
    
    list.forEach((element) => {
      if (element)
        for (var val of element) {
          updateGap.push(val);
        }
    });

   const updateAppt: any = [];

     list.forEach((element) => {
      if (element)
        for (var val of element) {
          updateAppt.push(val);
        }
    });

    this.$emit("answer", this.question.id, JSON.stringify(checked),null,updateGap,updateAppt);
  }
  mounted() {
    const { options, answer } = this.question;
    if (answer.value) {
      const values: string[] = JSON.parse(answer.value);
      options!.list.forEach((option) => {
        if (values.includes(option.value)) option.checked = true;
      });
    }
  }
}
